const BASE_URL = import.meta.env.VITE_BASE_API || '';
const GFS_URL = import.meta.env.VITE_GFS_API || '';

export { BASE_URL, GFS_URL };
